import { render, staticRenderFns } from "./crudQueryLocations.vue?vue&type=template&id=096b997a"
import script from "./crudQueryLocations.vue?vue&type=script&lang=js"
export * from "./crudQueryLocations.vue?vue&type=script&lang=js"
import style0 from "./crudQueryLocations.vue?vue&type=style&index=0&id=096b997a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports